import React from "react";
import {observer} from "mobx-react"
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import WOFShellBox from './boxes/wheel-of-fortune-shell.box';
import WOFColorsBox from "./boxes/wheel-of-fortune-colors.box";
import WOFWrapperBox from "./boxes/wheel-of-fortune-wrapper.box";
import { CyClass } from "../../../common/cy-classes";

export const WheelOfFortuneComponent = observer(class WheelOfFortuneComponent extends OrbitComponent {
    render() {
        const showSpin = this.services.playerOfferings.enableWheelOfFortuneAnimation;
        return (
            <WOFWrapperBox className={CyClass("cy-link-to-offer-wheel-of-fortune")}>
                <WOFShellBox>
                    <WOFColorsBox showSpin={showSpin} />
                </WOFShellBox>
            </WOFWrapperBox>
        )
    }
});
